export default __webpack_public_path__ + "assets/images/partner-default-logo3b95f874ecbf2e3c85ac98c561c94bea.png";